import type { CSSProperties, ReactNode } from 'react';

interface ShellProps {
    header?: ReactNode;
    nav?: ReactNode;
    bottomBar?: ReactNode;
    children?: ReactNode;
    /**
     * Inline-style overrides on the root element — used by LoadedShell to
     * push the Component's activeColor (and any future design-token
     * overrides) onto the cfg-root scope as CSS custom properties.
     */
    style?: CSSProperties;
    /**
     * Surfaces the active embed mode (`admin-preview` / `storefront`) on
     * the root element as `data-embed-mode="…"`. Storefront-plugin CSS
     * keys off this attribute when it overrides bundle styles for the
     * shop environment — that way the admin-iframe preview stays
     * untouched.
     */
    embedMode?: string;
}

/**
 * Outer layout container for a Configento instance. Mobile-first, single-column,
 * sticky bottom bar reserved at the foot. Header and nav slots are optional —
 * loading/error states omit them.
 */
export function Shell({ header, nav, bottomBar, children, style, embedMode }: ShellProps) {
    return (
        <div
            className="cfg-root"
            data-configento-root="v3"
            data-embed-mode={embedMode}
            style={style}
        >
            {header}
            {nav}
            <div className="cfg-main">{children}</div>
            {bottomBar}
        </div>
    );
}
